import React, { useMemo } from 'react';

import Checkbox from 'components/Checkbox';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { getFormattedPrice } from 'utils/currency';

import { Expense } from '../';
import { Container, Content, Row, Icon, Name, LogoRappi, Value, Currency, Arrow } from './styles';

interface Props {
  expense: Expense;
  isSelectable?: boolean;
  isChecked?: boolean;
  onSelect: (expense: Expense) => void;
}

const Item = ({ expense, isSelectable, isChecked, onSelect }: Props) => {
  const { t } = useStoreTranslation();
  const currencyValue = useMemo(() => {
    const formattedPrice = (value: number | undefined) => getFormattedPrice({ value, currency: expense.currency, t });
    return formattedPrice(expense.value);
  }, [expense.value, expense.currency, t]);

  const handleClick = () => {
    onSelect(expense);
  };

  return (
    <Container onClick={handleClick}>
      <Content>
        <Row>
          <Icon src={`/images/expense-types/${expense.type.toLowerCase()}.svg`} />
          <Name>{expense.name}</Name>
          <Value>{currencyValue?.formattedWithoutCode}</Value>
          <Currency>{currencyValue?.currency}</Currency>
          {!isSelectable ? <Arrow src="/images/right-arrow.svg" /> : <Checkbox circle checked={isChecked || false} />}
        </Row>
        {expense.fromRappi && (
          <Row>
            <LogoRappi src="/images/logo-rappi-oficial.svg" />
          </Row>
        )}
      </Content>
    </Container>
  );
};

export default Item;
